<template>
  <div
    class="slot-machine"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div
      class="slot-machine-container"
      :style="{
        backgroundImage: `url(${adaptOssImage(module.backgroundImage, 750)})`
      }"
    >
      <div class="mp-slot">
        <div class="mp-slot-box-wrapper">
          <div class="mp-slot-box">
            <div
              class="slot-group-wrapper"
              :style="{ transform: 'translateY(' + transY + 'px)' }"
              :class="{ animate: isAnimate1, transition1: isStart }"
            >
              <div
                v-for="(item, index) in imgList1"
                :key="index"
                class="slot-group"
              >
                <div class="slot-item">
                  <img :src="adaptOssImage(item.prize_img, 130)" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="mp-slot-box">
            <div
              class="slot-group-wrapper"
              :style="{ transform: 'translateY(' + transY + 'px)' }"
              :class="{ animate: isAnimate2, transition2: isStart }"
            >
              <div
                v-for="(item, index) in imgList2"
                :key="index"
                class="slot-group"
              >
                <div class="slot-item">
                  <img :src="adaptOssImage(item.prize_img, 130)" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="mp-slot-box">
            <div
              class="slot-group-wrapper"
              :style="{ transform: 'translateY(' + transY + 'px)' }"
              :class="{ animate: isAnimate3, transition3: isStart }"
            >
              <div
                v-for="(item, index) in imgList3"
                :key="index"
                class="slot-group"
              >
                <div class="slot-item">
                  <img :src="adaptOssImage(item.prize_img, 130)" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mark"></div>
      </div>
      <div
        class="press"
        @click="start"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <img
          v-show="click"
          :src="adaptOssImage(module.buttonImage, 380)"
          alt=""
        />
      </div>
    </div>
    <div
      class="time"
      :style="{
        backgroundImage: `url(${adaptOssImage(module.gridImage, 750)})`
      }"
    >
      您还有<span>{{ remainNum }}</span
      >次抽奖机会
    </div>
  </div>
</template>

<script>
import { ossImage } from '@/utils/oss_image'
import { DialogAlert } from '@/utils/dialog.js'
import { loginConfirm } from '@/utils/native_interactions/login'
import { tickets } from '@/defines/user'
import { platform } from '@/defines/environment'

export default {
  name: 'SlotMachine', // 老虎机
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      height: 87.5, // 单个数字高度
      click: true,
      goodsList: [],
      isStart: false,
      isAnimate1: false,
      isAnimate2: false,
      isAnimate3: false,
      imgList1: [],
      imgList2: [],
      imgList3: [],
      remainNum: '',
      activityId: '',
      lotteryResult: '',
      transY: 0
    }
  },
  created() {
    const goodsList = this.module.infoMap
    this.goodsList = goodsList
    this.remainNum = this.module.remainNum
    this.imgList1 = [goodsList[0]].concat(
      this.shuffle(goodsList.slice(0)),
      goodsList[1]
    )
    this.imgList2 = [goodsList[2]].concat(
      this.shuffle(goodsList.slice(0)),
      goodsList[3]
    )
    this.imgList3 = [goodsList[4]].concat(
      this.shuffle(goodsList.slice(0)),
      goodsList[5]
    )
  },
  methods: {
    adaptOssImage(src, width = 0, height = 0) {
      return ossImage({
        src,
        width,
        height
      })
    },
    handleTouchStart() {
      this.click = false
    },
    handleTouchEnd() {
      this.click = true
    },
    async start() {
      if (!tickets) {
        if (platform === 'android') {
          return loginConfirm()
        } else {
          return loginConfirm(location.href)
        }
      }
      if (this.flag) return
      if (this.remainNum === 0) {
        return DialogAlert('很抱歉，您没有抽奖机会了')
      }

      this.postMessage({
        id: this.module.id,
        event: this.module.events.lotteryTicker
      })

      this.transY = 0
      this.flag = true
      this.isStart = false
      this.isAnimate1 = true

      const res = await this.callModule(this.module.events.getLotteryResult)
      this.lotteryResult = res.lotteryResult

      if (res.ret) this.remainNum--
      if (this.remainNum < 0) this.remainNum = 0

      if (res.showSeq) {
        const index = this.goodsList.findIndex(v => v.show_seq === res.showSeq)
        this.setLotteryResult(index)
      } else {
        this.setLotteryResult()
      }

      setTimeout(() => {
        this.isAnimate2 = true
      }, 200)
      setTimeout(() => {
        this.isAnimate3 = true
      }, 400)
    },
    setLotteryResult(index) {
      const len = this.goodsList.length - 1
      const num1 = index === undefined ? this.randomNum(0, 3) : index
      const num2 = index === undefined ? this.randomNum(0, len) : index
      const num3 = index === undefined ? this.randomNum(4, len) : index
      this.imgList1[5] = this.goodsList[num1]
      this.imgList2[5] = this.goodsList[num2]
      this.imgList3[5] = this.goodsList[num3]
      setTimeout(() => {
        this.isAnimate1 = false
        this.isAnimate2 = false
        this.isAnimate3 = false
        this.isStart = true
        this.transY = -350
        setTimeout(() => {
          DialogAlert(this.lotteryResult).then(() => {
            this.flag = false
          })
        }, 2000)
      }, 2000)
    },
    randomNum(minNum, maxNum) {
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    },
    shuffle(arr) {
      // 数组乱序
      let length = arr.length
      if (!length) return []
      let randomIndex
      let temp
      while (length) {
        randomIndex = Math.floor(Math.random() * length--)
        temp = arr[randomIndex]
        arr[randomIndex] = arr[length]
        arr[length] = temp
      }
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.slot-machine-container {
  position: relative;

  height: 6.75rem;
  background-size: 100%;

  background-repeat: no-repeat;
}
.mp-slot {
  box-sizing: border-box;

  position: absolute;
  top: 0.55rem;
  left: 50%;
  transform: translateX(-50%);

  width: 5.65rem;
  height: 3.8rem;
  padding: 0 0.225rem;
  overflow: hidden;
}
.mark {
  position: absolute;
  left: 0;
  // transform: translate3d(0, 0, 0);

  width: 100%;
  height: 100%;

  background-image: url('../images/mark_bg.png');
  background-size: 100%;
}
.mp-slot-box-wrapper {
  display: flex;

  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);

  width: calc(100% - 0.45rem);
  height: 262.5px;

  justify-content: space-between;
}
.back-slot {
  position: absolute;

  width: 100%;
}
.press {
  position: absolute;
  bottom: 0.45rem;
  left: 50%;
  transform: translate3d(-50%, 0, 0);

  width: 3.8rem;
  height: 1.5rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.mp-slot-box {
  // transform: translate3d(0, 0, 0);

  width: 1.48rem;
  margin: 0 0.08rem;
  overflow: hidden;

  font-size: 30px;
}
.slot-group-wrapper {
  background: #fff;
  &.animate {
    animation-name: myfirst;
    animation-duration: 0.5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  &.transition1 {
    animation-name: myfirst2;
    animation-duration: 1s;
    animation-timing-function: cubic-bezier(0.24, 0.76, 0.64, 1.05);
  }
  &.transition2 {
    animation-name: myfirst2;
    animation-duration: 1.5s;
    animation-timing-function: cubic-bezier(0.24, 0.76, 0.64, 1.05);
  }
  &.transition3 {
    animation-name: myfirst2;
    animation-duration: 2s;
    animation-timing-function: cubic-bezier(0.24, 0.76, 0.64, 1.05);
  }
}
@keyframes myfirst {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-665px);
  }
}
@keyframes myfirst2 {
  from {
    // transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -350px, 0);
  }
}
.slot-item {
  box-sizing: border-box;

  width: 1.3rem;
  height: 87.5px;
  margin: 0 auto;
  padding: 11.25px 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.time {
  display: flex;

  position: relative;

  height: 0.95rem;

  background-repeat: no-repeat;

  justify-content: center;
  align-items: center;

  font-size: 0.4rem;
  color: #fff;
  background-size: 100% 100%;
  span {
    margin: 0 0.22rem;

    font-size: 0.6rem;
    color: #f8e71d;
  }
}
</style>
